import type { ReactElement } from 'react';

import {
  AvatarFallback,
  Avatar as AvatarPrimitive,
} from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import colorService from '@/services/color-service';

type AvatarProps = {
  firstname: string;
  lastname?: string;
  className?: string;
};

export function Avatar({
  firstname,
  lastname = '',
  className,
}: AvatarProps): ReactElement {
  const { getColorFromString } = colorService;
  const color = getColorFromString(`${firstname}${lastname}`, 50, 45);

  return (
    <AvatarPrimitive className={cn('rounded-full', className)}>
      <AvatarFallback
        className={cn('rounded-full', className)}
        hslColor={color}
      >
        {firstname.split('').shift()}
        {lastname.split('').shift()}
      </AvatarFallback>
    </AvatarPrimitive>
  );
}
